const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ helpers
const { formatText } = require('core/i18n').i18n;
const transfersHelper = require('utilities/transfersHelper');
// @ components
const OKSelect = require('components/commons/OKSelect/OKSelect');
const { InputSafe } = require('commonsComponents/inputSafe');
const SearchCountries = require('components/searchCountries/searchCountries');
// @ constants
const { currenciesOptions } = require('constants/currencies');
const NAME_MAX_LENGTH = 50;
const ALIAS_MAX_LENGTH = 50;
const CITY_MAX_LENGTH = 50;
const ADDRESS_MAX_LENGTH = 100;

class AddBeneficiaryProfile extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            name: props.immAddBeneficiary.get('name'),
            alias: props.immAddBeneficiary.get('alias'),
            address: props.immAddBeneficiary.get('address'),
            city: props.immAddBeneficiary.get('city')
        };

        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleAliasChange = this.handleAliasChange.bind(this);
        this.handleAddressChange = this.handleAddressChange.bind(this);
        this.handleCityChange = this.handleCityChange.bind(this);
        this.handleAliasBlur = this.handleAliasBlur.bind(this);
        this.handleNameBlur = this.handleNameBlur.bind(this);
        this.handleAddressBlur = this.handleAddressBlur.bind(this);
        this.handleCityBlur = this.handleCityBlur.bind(this);
        this.isAliasRepeated = this.isAliasRepeated.bind(this);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleCountryChange = this.handleCountryChange.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.alias !== nextProps.immAddBeneficiary.get('alias')) {
            // This is the case when add beneficiary form is filled with existing beneficiary to be able to edit it.
            this.setState({
                name: nextProps.immAddBeneficiary.get('name'),
                alias: nextProps.immAddBeneficiary.get('alias'),
                address: nextProps.immAddBeneficiary.get('address'),
                city: nextProps.immAddBeneficiary.get('city')
            });
        }
    }

    buildOutsideSepaExtraFields() {
        const { immAddBeneficiary } = this.props;

        const labelAddress = formatText('transferSummary-step1BeneficiaryAddress');
        const labelCity = formatText('transferSummary-step1BeneficiaryCity');
        const isSepa = transfersHelper.isSepa(
            immAddBeneficiary.get('country'),
            immAddBeneficiary.get('currency')
        );

        let content;
        if (!isSepa) {
            content = (
                <div className="add-beneficiary-step-one__form-section">
                    <div className="row no-outside-gutter">
                        <div className="col-xs-6">
                            <InputSafe
                                id="inp_AddBeneficiaryStep1_BeneficiaryAddress"
                                type="text"
                                autoComplete="off"
                                label={labelAddress}
                                value={this.state.address}
                                onChange={this.handleAddressChange}
                                onBlur={this.handleAddressBlur}
                                maxLength={ADDRESS_MAX_LENGTH}
                            />
                        </div>
                        <div className="col-xs-6">
                            <InputSafe
                                id="inp_AddBeneficiaryStep1_BeneficiaryCity"
                                type="text"
                                autoComplete="off"
                                label={labelCity}
                                value={this.state.city}
                                onChange={this.handleCityChange}
                                onBlur={this.handleCityBlur}
                                maxLength={CITY_MAX_LENGTH}
                            />
                        </div>
                    </div>
                </div>
            );
        }

        return content;
    }

    handleAddressBlur(evt) {
        this.props.actions.setBeneficiaryAddress(evt.target.value);
    }

    handleAddressChange(evt) {
        this.setState({
            address: evt.target.value
        });
    }

    isAliasHasSpecialChars(alias) {
        return !!alias ? !!(alias.match(/[^\w\s]/gi) || []).length : false;
    }

    handleAliasBlur(evt) {
        const alias = evt.target.value.trim();
        const isValid = !!alias && !this.isAliasRepeated(alias) && !this.isAliasHasSpecialChars(alias);
        //update state after trim , and the update reducer
        this.setState(
            {
                alias: alias
            },
            () => {
                this.props.actions.setBeneficiaryAlias(alias, isValid);
            }
        );
    }

    handleAliasChange(evt) {
        this.setState({
            alias: evt.target.value
        });
    }

    handleCityBlur(evt) {
        this.props.actions.setBeneficiaryCity(evt.target.value);
    }

    handleCityChange(evt) {
        this.setState({
            city: evt.target.value
        });
    }

    handleCountryChange(country) {
        const {
            actions: { handleBeneficiaryCountry, setIbanOnCountryChange },
            immAddBeneficiary
        } = this.props;
        handleBeneficiaryCountry(country);
        setIbanOnCountryChange(immAddBeneficiary.get('ibanIsDirty'));
    }

    handleNameBlur(evt) {
        const beneficiaryName = evt.target.value.trim();
        this.props.actions.setBeneficiaryName(beneficiaryName);
    }

    handleNameChange(evt) {
        this.setState({
            name: evt.target.value
        });
    }

    isAliasRepeated(alias) {
        const { immBeneficiaries } = this.props;
        return immBeneficiaries.get('byOrder').some(beneficiaryId => {
            return (
                immBeneficiaries.getIn(['byId', beneficiaryId, 'alias']).toLowerCase() ===
                alias.toLowerCase()
            );
        });
    }

    render() {
        const { immAddBeneficiary, immBeneficiaries, actions } = this.props;

        const labelName = formatText('addBeneficiary-step1BeneficiaryName');

        const nameRequiredAlertVisible =
            immAddBeneficiary.get('nameIsDirty') && immAddBeneficiary.get('name') === '';
        const nameRequiredErrorMsg = formatText('transferSummary-requiredMessage', [labelName]);

        const labelAlias = formatText('transferSummary-step1BeneficiaryAlias');

        const aliasRequiredAlertVisible =
            immAddBeneficiary.get('aliasIsDirty') && immAddBeneficiary.get('alias') === '';
        const aliasRepeatedAlertVisible =
            immAddBeneficiary.get('aliasIsDirty') && !immAddBeneficiary.get('aliasIsValid');
        const aliasSplCharAlertVisible = this.isAliasHasSpecialChars(immAddBeneficiary.get('alias'));
        let aliasErrorMsg = formatText('transferSummary-step1AliasRepeated');

        const labelCountry = formatText('transferSummary-step1BeneficiaryCountryDestiny');
        const labelCurrency = formatText('transferSummary-step1Currency');

        const outsideSepaExtraFields = this.buildOutsideSepaExtraFields();

        if (aliasRequiredAlertVisible) {
            aliasErrorMsg = formatText('transferSummary-requiredMessage', [labelAlias]);
        } else if (aliasSplCharAlertVisible) {
            aliasErrorMsg = formatText('transferSummary-step1AliasSpecialCharError');
        }

        const originalAlias = immBeneficiaries.getIn(['byId', immAddBeneficiary.get('beneficiaryId'), 'alias']);

        return (
            <div className="add-beneficiary-profile">
                <div className="add-beneficiary-step-one__form-section">
                    <div className="row no-outside-gutter">
                        <div className="col-xs-6">
                            <InputSafe
                                id="inp_AddBeneficiaryStep1_BeneficiaryName"
                                type="text"
                                autoComplete="off"
                                maxLength={NAME_MAX_LENGTH}
                                label={labelName}
                                value={this.state.name}
                                onChange={this.handleNameChange}
                                onBlur={this.handleNameBlur}
                                errorState={nameRequiredAlertVisible}
                                errorMessage={nameRequiredErrorMsg}
                            />
                        </div>
                        <div className="col-xs-6">
                            <InputSafe
                                id="inp_AddBeneficiaryStep1_BeneficiaryAlias"
                                type="text"
                                autoComplete="off"
                                maxLength={ALIAS_MAX_LENGTH}
                                label={labelAlias}
                                value={this.state.alias}
                                onChange={this.handleAliasChange}
                                onBlur={this.handleAliasBlur}
                                errorState={aliasRequiredAlertVisible || aliasRepeatedAlertVisible || aliasSplCharAlertVisible}
                                errorMessage={aliasErrorMsg}
                                disabled={immAddBeneficiary.get('isEditing') && !this.isAliasHasSpecialChars(originalAlias)}
                            />
                        </div>
                    </div>
                </div>
                <div className="add-beneficiary-step-one__form-section">
                    <div className="row no-outside-gutter">
                        <div className="col-xs-6">
                            <SearchCountries
                                label={labelCountry}
                                autosize={false}
                                selectedValue={immAddBeneficiary.get('country')}
                                onSelect={this.handleCountryChange}
                            />
                        </div>
                        <div className="col-xs-6">
                            <OKSelect
                                label={labelCurrency}
                                options={currenciesOptions()}
                                value={immAddBeneficiary.get('currency')}
                                searchable={false}
                                clearable={false}
                                onChange={actions.handleCurrency}
                            />
                        </div>
                    </div>
                </div>
                {outsideSepaExtraFields}
            </div>
        );
    }
}

AddBeneficiaryProfile.propTypes = {
    immBeneficiaries: PropTypes.object,
    immAddBeneficiary: PropTypes.object,
    actions: PropTypes.object
};

module.exports = AddBeneficiaryProfile;
